import { Box } from "@material-ui/core";
import { color, px } from "Configs/theme";
import ErrorView from "Views/ErrorView";
import React, { FC } from "react";

interface Props {
	error: Error;
}

export const AuthErrorView: FC<Props> = (props) => {
	const { error } = props;
	const token = "token" in error ? error["token"] : null;

	return (
		<ErrorView error={error}>
			{token && (
				<Box
					color={color.lightText}
					padding={px.m}
					fontSize={px.s}
					style={{
						wordBreak: "break-word",
						opacity: 0.3,
					}}
				>
					Customer support error code: {token}
				</Box>
			)}
		</ErrorView>
	);
};
